<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <p>Mail Attachments</p>
    <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="m-0" *ngIf="isDocumentView && !is_Schedule_Document">
  <app-document-view [viewData]="viewData" [ViewOnly]="true"></app-document-view>
</div> 
<div mat-dialog-content class="m-0" *ngIf="isDocumentView && is_Schedule_Document"> 
 <app-schedule-view [schDoc]="viewSchData" [ViewOnly]="true"></app-schedule-view> 
</div>
<div mat-dialog-content class="m-0" *ngIf="!isDocumentView">
  <app-mail-view [viewData]="viewData"></app-mail-view>
</div>